define(
  'app/views/subcategories_section_view',['app/setup'],
  function(takhfifan) {

  takhfifan.SubcategoriesSectionView = takhfifan.BaseView.extend({

    events: {
      'click .subcategory-label a' : 'toggleCategory'
    },

    initialize: function(options) {
      this.getDealsList();
    },

    getDealsList: function() {
      var $dealsList = $(".tkh-subcategories-deals-list");
      if($dealsList.length) {
        this.$dealsList = $($dealsList[0]);
      } else {
        this.$dealsList = null;
      }
    },

    toggleCategory: function(event) {
      event.preventDefault();
      var $target = $(event.target).closest("li");
      takhfifan.eventHub.trigger('subcategory-filtered',$target.data('categoryid'));
      var _this = this;
      if (!($target.hasClass('active'))) {
        this.$el.find('li.active').each(function() {
          $(this).removeClass('active');
          _this.hideProducts($(this).attr('data-categoryid'));
        });

        $target.addClass('active');
        _this.showProducts($target.attr('data-categoryid'));
        takhfifan.eventHub.trigger('lazyLoad:notify');
      }
    },

    showProducts: function(categoryId) {
      if(this.$dealsList) {

        var $products = this.findProducts(categoryId);
        if (categoryId == '-1') {
          $products = this.$dealsList.find('.deal');
          this.$dealsList.removeClass('filtered');
        }else{
          this.$dealsList.addClass('filtered');
        }
        $products.show();

        if (categoryId !== '-1') {
          $products.each(function (index) {
            var $this = $(this);
            $this.removeClass('visible-item-3n visible-item-2n');
            if ((index + 1) % 3 === 0) {
              $this.addClass('visible-item-3n')
            }
            if ((index + 1) % 2 === 0) {
              $this.addClass('visible-item-2n')
            }
          });
        }
      }
    }, 

    hideProducts: function(categoryId) {
      if(this.$dealsList) {
        var $products = this.findProducts(categoryId);
        if (categoryId == '-1') {
          $products = this.$dealsList.find('.deal'); 
        }
        $products.hide();
        $products.removeClass('visible-item-3n visible-item-2n');
      }
    },

    findProducts: function(category){
      return this.$dealsList.find(".deal[data-categoryid~='"+category+"']");
    }

  });
});

